<template>
  <div class="shoppe" v-loading.fullscreen.lock="fullscreenLoading">
    <el-form label-position="right" label-width="150px">
      <el-form-item label="当前买手店" v-if="!isPlatform">{{ vendorInfo.vendorNameAlias }}</el-form-item>
      <el-form-item label="规则名称（必填）">
        <el-input v-model="form.name" clearable style="width: 350px;" maxlength="50" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="规则范围（必填）">
        <el-select v-model="form.scope" placeholder="请选择" style="width: 350px;">
          <el-option label="全店" :value="1" v-if="!isPlatform" :disabled="vendorInfo.hasAll"></el-option>
          <el-option label="类目" :value="2"></el-option>
          <el-option label="类目+品牌" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="类目（必填）" v-if="form.scope === 2 || form.scope === 3">
        <el-cascader
          v-model="form.categoryIds"
          :options="form.scope === 2 ? categoryListWithDisabled : categoryList"
          :props="optionProps"
          collapse-tags
          clearable
          style="width: 350px;"
        ></el-cascader>
      </el-form-item>
      <el-form-item label="品牌（必填）" v-if="form.scope === 3">
        <BrandSelect v-model="form.brandIds" :data="brandList" multiple collapse-tags filterable clearable style="width: 350px;"></BrandSelect>
      </el-form-item>
      <el-form-item label="" v-if="form.scope === 3">
        <el-tag v-for="(tag, index) in brandTags" :key="index" style="margin:0 10px 5px 0;" closable @close='closeTag(index, "brandIds")'>
          {{ tag.label }}
        </el-tag>
      </el-form-item>
    </el-form>

    <Steps title="Country Size 取值规则：" :templateList="templateList" :data="form.countrySizeCleanRuleDetailsVo"></Steps>

    <Steps class="mt50" title="Size 取值规则：" :templateList="templateList" :data="form.sizeCleanCleanRuleDetailsVo"></Steps>

    <el-form class="mt50" label-position="right" label-width="130px">
      <el-form-item label="备注">
        <el-input type="textarea" v-model="form.comment" :rows="5" style="width: 350px;" maxlength="1000" show-word-limit></el-input>
      </el-form-item>
      <p class="gray">枚举规则设置（基于以上country size和size的清洗结果继续按照以下枚举规则进行最后的清洗）</p>
      <el-form-item class="mt10" label="导入枚举规则文件">
        <div class="upload-container">
          <div class="upload-btn">
            <el-button type="primary" icon="el-icon-upload" size="medium" plain>添加文件</el-button>
            <input @change="changeFile" accept=".xlsx" type="file" />
          </div>
          <el-button type="text" @click="downloadTemplate">下载文件模板</el-button>
        </div>
        <p class="supply-tip">支持文件： Excel或UTF-8格式的WPS文件</p>
        <template v-if="form.mappingFileName">
          <div class="file-item bg-gray"><i class="el-icon-document"></i> {{ form.mappingFileName }}</div>
          <el-button class="ml20" type="text" size="mini" @click="downloadFile(form.mappingFileUrl)">下载</el-button>
          <el-button class="ml10" type="text" size="mini" @click="removeFile()">删除</el-button>
        </template>
      </el-form-item>
    </el-form>

    <p>测试规则：</p>
    <el-row :gutter="20" class="mt10">
      <el-col :xs="24" :sm="24" :md="12" :lg="10" :xl="8">
        <p class="gray">请输入测试数据（country size和size，以逗号分隔，空请使用空格代替), 以上如有设置枚举规则，该规则不在测试范围</p>
        <div class="test-container">
          <div class="left">
            <p class="mt10">country size</p>
            <el-input class="mt10" type="textarea" v-model="testForm.countrySize" :rows="5"></el-input>
          </div>
          <div class="right">
            <p class="mt10">size</p>
            <el-input class="mt10" type="textarea" v-model="testForm.size" :rows="5"></el-input>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="14" :xl="12">
        <el-button type="primary" size="medium" plain @click="testRuleFile" :loading="testLoading">执行测试</el-button>
        <p class="mt10">测试结果（显示的清洗结果仅针对当前规则计算而来，最终结果有可能受其他规则影响导致实际的清洗结果与当前测试结果有出入）</p>
        <p v-for="(item, index) in testResultList" :key="index">
          {{index + 1}}. 清洗结果：{{ item.result }}。
          <span v-if="!item.failureDetail">清洗前（country size/size）：{{ item.before }}； 清洗后（country size/size）：{{ item.after }}。</span>
          <span v-else>{{ item.failureDetail }}</span>
        </p>
      </el-col>
    </el-row>

    <el-dialog title="导入失败" :visible.sync="dialogVisible" width="500px">
      <el-link type="primary" @click="downloadFile(failFileUrl)">下载结果文件</el-link>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>

    <el-button class="mt50" type="primary" @click="submitForm">提 交</el-button>
  </div>
</template>

<script>
import Client from "@/utils/client.js";
import { downloadUrlFile } from '@/utils/functions';
import { fileUpload } from '../../api/merchants';
import {
  getSizeCleanRuleVendorInfo,
  testSizeCleanRule,
  getSizeCleanRuleTemplateList,
  getSizeCleanRuleDetail,
  validationSizeCleanRuleFile,
  submitSizeCleanRule,
} from "./api";
import {
  getCategory,
} from '../../api/mapping';
import { getBrandList } from '../../api/merchants';
import BrandSelect from '../shared/brandSelect.vue';
import Steps from './steps';

export default {
  components: {
    BrandSelect,
    Steps,
  },
  data() {
    return {
      fullscreenLoading: false,
      isPlatform: this.$route.path.includes('/platform/'),
      vendorInfo: {
        categoryIds: [],
      },
      templateList: [],
      vendorList: [],
      brandList: [],
      optionProps: {
        value: 'categoryId',
        children: 'children',
        label: 'chineseName',
        expandTrigger: "hover",
        emitPath: false,
        checkStrictly: false,
        multiple: true
      },
      categoryList: [],
      form: {
        vendorId: this.$route.params.vendorId || 0, // 平台规则为0
        sizeCleanRuleId: this.$route.params.id,
        name: null,
        scope: null,
        categoryIds: [],
        brandIds: [],
        countrySizeCleanRuleDetailsVo: {
          source: 2,
          sizeCleanRuleDetails: [],
        },
        sizeCleanCleanRuleDetailsVo: {
          source: 1,
          sizeCleanRuleDetails: [],
        },
        mappingFileUrl: null,
        mappingFileName: '',
        comment: null,
      },
      countrySizeTemplateId: null,
      sizeTemplateId: null,
      testForm: {
        countrySize: '',
        size: '',
      },
      testResultList: [],
      testLoading: false,
      dialogVisible: false,
      failFileUrl: null,
    };
  },
  computed: {
    brandTags() {
      // return this.brandList.filter(item => this.form.brandIds.includes(item.value));
      return this.form.brandIds.map(item => {
        const brand = this.brandList.find(item2 => item2.value === item);
        return brand;
      })
    },
    categoryListWithDisabled() {
      return this.categoryList.map(item => {
        item.children.map(item2 => {
          item2.children.map(item3 => {
            item3.disabled = this.vendorInfo.categoryIds.includes(item3.categoryId);
            return item3;
          })
          return item2;
        })
        return item;
      })
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      getCategory({includeUnisex: false}).then(res => {
        if (res.data && res.data.data) {
          this.categoryList = res.data.data;
        }
      })
      if (!this.isPlatform) {
        getSizeCleanRuleVendorInfo(this.$route.params.vendorId).then(res => {
          if (res.data && res.data.data) {
            this.vendorInfo = res.data.data;
            this.vendorInfo.categoryIds = this.vendorInfo.categoryIds.filter(item => !this.form.categoryIds.includes(item));

            if (this.$route.path.includes('/create/')) {
              if (this.vendorInfo.hasAll) {
                this.form.scope = 3;
              } else {
                this.form.scope = 1;
              }
            }
          }
        });
      }
      getSizeCleanRuleTemplateList().then(res => {
        if (res.data && res.data.data) {
          this.templateList = res.data.data.map(item => {
            return item;
          });
        }
      });
      getBrandList().then(res => {
        if (res.data) {
          const map = {};
          this.brandList = res.data.map((item) => {
            map[item.brandId] = item.englishName;
            return {
              value: item.brandId,
              label: item.englishName,
            }
          });
          this.brandMap = map;
        }
      });
      if (this.$route.params.id) {
        getSizeCleanRuleDetail({
          id: this.$route.params.id,
        }).then(res => {
          if (res.data && res.data.data) {
            const data = res.data.data;
            this.form.name = data.name;
            this.form.scope = data.scope;
            this.form.categoryIds = data.categoryIds || [];
            this.form.brandIds = data.brandIds || [];
            this.form.countrySizeCleanRuleDetailsVo = data.countrySizeCleanRuleDetailsVo || {
              source: 2,
              sizeCleanRuleDetails: [],
            };
            this.form.sizeCleanCleanRuleDetailsVo = data.sizeCleanCleanRuleDetailsVo || {
              source: 1,
              sizeCleanRuleDetails: [],
            };
            this.form.mappingFileUrl = data.mappingFileUrl;
            this.form.mappingFileName = data.mappingFileName;
            this.form.comment = data.comment;
            this.vendorInfo.categoryIds = this.vendorInfo.categoryIds.filter(item => !this.form.categoryIds.includes(item));
          }
        })
      }
    },
    testRuleFile() {
      this.testResultList = [];
      if (this.form.countrySizeCleanRuleDetailsVo.length === 0) {
        this.$message('请设置 Country Size 取值规则');
        return;
      }
      if (this.form.sizeCleanCleanRuleDetailsVo.length === 0) {
        this.$message('请设置 Size 取值规则');
        return;
      }
      if (!this.form.countrySizeCleanRuleDetailsVo.sizeCleanRuleDetails.every(rule => rule.ruleParamVoList.every(item => item.value))) {
        this.$message('规则参数不能为空');
        return;
      }
      if (!this.form.sizeCleanCleanRuleDetailsVo.sizeCleanRuleDetails.every(rule => rule.ruleParamVoList.every(item => item.value))) {
        this.$message('规则参数不能为空');
        return;
      }
      if (!this.testForm.size) {
        this.$message('请输入要测试的尺码');
        return;
      }
      this.form.countrySizeCleanRuleDetailsVo.sizeCleanRuleDetails.forEach((item, index) => {
        item.ruleSort = index;
      });
      this.form.sizeCleanCleanRuleDetailsVo.sizeCleanRuleDetails.forEach((item, index) => {
        item.ruleSort = index;
      });
      this.testLoading = true;
      testSizeCleanRule({
        countrySizes: this.testForm.countrySize,
        sizes: this.testForm.size,
        countrySizeCleanRuleDetailsVo: this.form.countrySizeCleanRuleDetailsVo,
        sizeCleanCleanRuleDetailsVo: this.form.sizeCleanCleanRuleDetailsVo,
      }).then(res => {
        if (res.data.success) {
          this.testResultList = res.data.data || [];
        } else {
          this.$message.error(res.data.message || '系统异常，请稍后再试');
        }
        this.testLoading = false;
      }).catch(() => {
        this.$message.error('系统异常，请稍后再试');
        this.testLoading = false;
      })
    },
    downloadTemplate() {
      this.downloadFile('https://product-sts.oss-cn-shanghai.aliyuncs.com/tmp/尺码清洗Template.xlsx');
    },
    downloadFile(url) {
      downloadUrlFile(url);
    },
    removeFile() {
      this.form.mappingFileUrl = null;
      this.form.mappingFileName = null;
    },
    async changeFile(e) {
      if (e && e.target && e.target.files && e.target.files[0]) {
        const file = e.target.files[0];
        if (!/\.xlsx?$/.test(String(file.name).toLowerCase())) {
          this.$message.error('请上传excel或wps的xlsx格式文件');
          return;
        }
        if (file.size > 50 * 1024 * 1024) {
          this.$message.error('文件太大了');
          return;
        }
        this.fullscreenLoading = true;
        const confRes = await fileUpload();
        const OSSClient = Client(confRes.data.data);
        const fileName = this.random_string(6) + '_' + new Date().getTime() + '.' + file.name.split('.').pop();
        const random_name = 'tmp/' + fileName;
        const res = await OSSClient.put(random_name, file);
        try {
          const validRes = await validationSizeCleanRuleFile({
            fileUrl: res.url,
            fileName: file.name.substring(file.name.lastIndexOf('/')),
          });
          if (validRes.data.success) {
            this.form.mappingFileUrl = res.url;
            this.form.mappingFileName = file.name.substring(file.name.lastIndexOf('/'));
          } else {
            this.failFileUrl = validRes.data.data;
            this.dialogVisible = true;
          }
        } catch (error) {
          this.$message.error('系统异常，请稍后再试');
        }
        this.fullscreenLoading = false;
      }
      e.target.value = '';
    },
    random_string(len) {
      len = len || 32;
      let chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz12345678', maxPos = chars.length, pwd = '';
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    submitForm() {
      if (!this.form.name) {
        this.$message('请输入规则名称');
        return;
      }
      if (!this.form.scope) {
        this.$message('请选择适用范围');
        return;
      }
      if ((this.form.scope === 2 || this.form.scope === 3) && this.form.categoryIds.length === 0) {
        this.$message('请选择类目');
        return;
      }
      if (this.form.scope === 3 && this.form.brandIds.length === 0) {
        this.$message('请选择品牌');
        return;
      }
      if (this.form.countrySizeCleanRuleDetailsVo.length === 0) {
        this.$message('请设置 Country Size 取值规则');
        return;
      }
      if (this.form.sizeCleanCleanRuleDetailsVo.length === 0) {
        this.$message('请设置 Size 取值规则');
        return;
      }
      if (!this.form.countrySizeCleanRuleDetailsVo.sizeCleanRuleDetails.every(rule => rule.ruleParamVoList.every(item => item.value))) {
        this.$message('规则参数不能为空');
        return;
      }
      if (!this.form.sizeCleanCleanRuleDetailsVo.sizeCleanRuleDetails.every(rule => rule.ruleParamVoList.every(item => item.value))) {
        this.$message('规则参数不能为空');
        return;
      }
      if (!this.form.countrySizeCleanRuleDetailsVo.sizeCleanRuleDetails.every(rule => rule.ruleParamVoList.every(item => item.value))) {
        this.$message('规则参数不能为空');
        return;
      }
      if (!this.form.sizeCleanCleanRuleDetailsVo.sizeCleanRuleDetails.every(rule => rule.ruleParamVoList.every(item => item.value))) {
        this.$message('规则参数不能为空');
        return;
      }
      this.form.countrySizeCleanRuleDetailsVo.sizeCleanRuleDetails.forEach((item, index) => {
        item.ruleSort = index;
      });
      this.form.sizeCleanCleanRuleDetailsVo.sizeCleanRuleDetails.forEach((item, index) => {
        item.ruleSort = index;
      });
      this.fullscreenLoading = true;
      submitSizeCleanRule(this.form).then(res => {
        if (res.data.success) {
          this.$message.success('提交成功');
          if (this.isPlatform) {
            this.$router.push('/sizeAccess/platformRules');
          } else {
            this.$router.push('/sizeAccess/vendorRules/' + this.$route.params.vendorId);
          }
        } else {
          this.$message.error(res.data.message || '系统异常，请稍后再试');
        }
        this.fullscreenLoading = false;
      }).catch(() => {
        this.$message.error('系统异常，请稍后再试');
        this.fullscreenLoading = false;
      })
    },
    closeTag(index, field) {
      this.form[field].splice(index, 1);
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
  font-size: 14px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.mt10 {
  margin-top: 10px;
}
.mt15 {
  margin-top: 15px;
}
.mt20 {
  margin-top: 20px;
}
.mt50 {
  margin-top: 50px;
}
.ml10 {
  margin-left: 10px;
}
.ml20 {
  margin-left: 20px;
}
.label {
  color: #606266;
}
.value {
  margin-right: 20px;
  font-size: 16px;
}
.upload-container {
  display: flex;

  .upload-btn {
    position: relative;
    margin-right: 50px;

    input {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
}
.gray {
  color: #909399;
}
.bg-gray {
  background-color: #f2f2f2;
}
.supply-tip {
  margin-top: 10px;
  color: #909399;
  font-size: 12px;
  line-height: 1.5;
}
.file-item {
  display: inline-block;
  padding: 5px 10px;
  margin-top: 10px;
  border-radius: 4px;
  line-height: 1.5;
}
.test-container {
  display: flex;
  justify-content: space-between;

  .left,
  .right {
    width: 48%;
  }
}
</style>
